import { useEffect, useState } from "react";
import { leaveAPI } from '../../api/leaveAPI';
import UserPcode from '../../components/userPcode';
import { toast } from 'react-toastify';
import Spinner from "../../components/spinner/spinner";
import ExpandableTableRow from '../../components/expandableTableRow';
import LeaveDetailsSummary from '../../components/leaveDetailsSummary';
import LeaveDetailsModal from '../../components/modal/leaveDetails';
import './allLeaveDetails.css';

export default function AllLeaveDetails() {

    const [isProcessing, setIsProcessing] = useState(false);

    const [selectedPcode, setSelectedPcode] = useState('');
    const [fromDate, setFromDate] = useState("")
    const [toDate, setToDate] = useState("")

    const [empLeave, setEmpLeave] = useState([])
    const [filteredLeaves, setFilteredLeaves] = useState([])

    // Modal state
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedLeaveData, setSelectedLeaveData] = useState(null);

    // View options
    const [viewMode, setViewMode] = useState('expandable'); // 'expandable' or 'modal'

    // Filter and search state
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedLeaveType, setSelectedLeaveType] = useState('');
    const [leaveTypes, setLeaveTypes] = useState([]);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    const [paginatedLeaves, setPaginatedLeaves] = useState([]);

    const handlePreview = () => {

        if (fromDate.trim().length === 0) { toast.warn('Please select a Date From'); return; }

        if (toDate.trim().length === 0) { toast.warn('Please select a Date To'); return; }

        if (new Date(fromDate) > new Date(toDate)) { toast.warn('Invalid Date Range'); return; }

        setIsProcessing(true);

        loadEmployeeLeaveDetails();
    }

    const loadEmployeeLeaveDetails = () => {
        leaveAPI.getAllEmployeeLeaveDetails(fromDate, toDate, selectedPcode)
            .then((data) => {                
                setEmpLeave(data);
                setFilteredLeaves(data);
              
                const uniqueLeaveTypes = [...new Set(data.map(leave => leave.leaveTypeName))];
                setLeaveTypes(uniqueLeaveTypes);
            })
            .finally(() => setIsProcessing(false));
    }

    const onChangePCode = (pcode) => { }

    // Filter and search functionality
    const applyFilters = () => {
        let filtered = empLeave;

        // Apply search filter
        if (searchTerm) {
            filtered = filtered.filter(leave =>
                leave.employeeName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                leave.employeeCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                leave.reason?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Apply leave type filter
        if (selectedLeaveType) {
            filtered = filtered.filter(leave => leave.leaveTypeName === selectedLeaveType);
        }

        setFilteredLeaves(filtered);
        setCurrentPage(1); // Reset to first page when filters change
    };

    // Pagination logic
    const applyPagination = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        setPaginatedLeaves(filteredLeaves.slice(startIndex, endIndex));
    };

    useEffect(() => {
        applyFilters();
    }, [searchTerm, selectedLeaveType, empLeave]);

    useEffect(() => {
        applyPagination();
    }, [filteredLeaves, currentPage]);

    const totalPages = Math.ceil(filteredLeaves.length / itemsPerPage);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const clearFilters = () => {
        setSearchTerm('');
        setSelectedLeaveType('');
    };

    const handleViewDetails = (leaveData) => {
        if (viewMode === 'modal') {
            setSelectedLeaveData(leaveData);
            setIsModalOpen(true);
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedLeaveData(null);
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        return new Date(dateString).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric'
        });
    };

    useEffect(() => {
        const currentDate = new Date();

        const firstDayPrevMonth = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() - 1,
            1
        );

        const firstDayCurrentMonth = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() + 1,
            1
        );

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        setFromDate(formatDate(firstDayPrevMonth));
        setToDate(formatDate(firstDayCurrentMonth));
    }, []);

    return (
        <>
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 p-2 rounded contentLeveApproval form__body">
                    <div className="row mt-1">
                        <div className='col-2 col-sm-2 col-md-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4  text-start'></div>
                        <div className="col-8 col-sm-8 col-md-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                            <h4>All Approved Leaves</h4>
                        </div>
                        <div className="col-2 col-sm-2 col-md-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center"></div>
                    </div>

                    <div className="row">
                        <div className='col-0 col-sm-0 col-md-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                            <div className="input-group input-group-sm">
                                <UserPcode setSelectedPcode={setSelectedPcode} triggerOnChangePCode={onChangePCode} />
                            </div>
                        </div>
                        <div className='col-0 col-sm-0 col-md-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                    </div>
                    <div className="row">
                        <div className='col-0 col-sm-0 col-md-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3">
                            <div className="input-group input-group-sm">
                                <input value={fromDate} onChange={(e) => setFromDate(e.target.value)} type="date" className="form-control" placeholder='From Date' />
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3">
                            <div className="input-group input-group-sm">
                                <input value={toDate} onChange={(e) => setToDate(e.target.value)} type="date" className="form-control" placeholder='To Date' />
                            </div>
                        </div>
                        <div className='col-0 col-sm-0 col-md-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                    </div>
                    <div className="row mt-1">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 col-xxl-9 text-end">
                            <div className="btn-group btn-group-sm">
                                <button onClick={handlePreview} type="button" className="btn btn-success">Preview</button>
                            </div>
                        </div>
                        <div className='col-0 col-sm-0 col-md-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                    </div>

                    {/* Search and Filter Section */}
                    {empLeave.length > 0 && !isProcessing && (
                        <div className="row">
                            <div className="col-12">
                                <div className="filter-section p-2 bg-light rounded">
                                    <div className="row align-items-center">
                                        <div className="col-lg-4 col-md-6 mb-2">
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text">
                                                    <i className="fas fa-search"></i>
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search by employee name, code, or reason..."
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-2">
                                            <select
                                                className="form-select form-select-sm"
                                                value={selectedLeaveType}
                                                onChange={(e) => setSelectedLeaveType(e.target.value)}
                                            >
                                                <option value="">All Leave Types</option>
                                                {leaveTypes.map((type, index) => (
                                                    <option key={index} value={type}>{type}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-lg-2 col-md-6 mb-2">
                                            <button
                                                className="btn btn-sm btn-outline-secondary w-100"
                                                onClick={clearFilters}
                                                disabled={!searchTerm && !selectedLeaveType}
                                            >
                                                <i className="fas fa-times me-1"></i>Clear
                                            </button>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-2">
                                            <small className="text-muted">
                                                Showing {filteredLeaves.length} of {empLeave.length} leaves
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-1'>
                            {/* Table Header with Actions */}
                            {empLeave.length > 0 && !isProcessing && (
                                <div className="table-header-actions mb-2 p-2 bg-light rounded d-flex justify-content-between align-items-center flex-wrap">
                                    <div className="mb-2 mb-md-0">
                                        <h6 className="mb-0">
                                            <i className="fas fa-table me-2"></i>
                                            Leave Records ({filteredLeaves.length} {filteredLeaves.length === 1 ? 'record' : 'records'})
                                        </h6>
                                    </div>
                                    <div className="d-flex align-items-center flex-wrap">
                                        <small className="text-muted me-3">
                                            View Mode:
                                        </small>
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 text-end">
                                            <div className="btn-group btn-group-sm" role="group">
                                                <input
                                                    type="radio"
                                                    className="btn-check"
                                                    name="viewMode"
                                                    id="expandableView"
                                                    checked={viewMode === 'expandable'}
                                                    onChange={() => setViewMode('expandable')}
                                                />
                                                <label className="btn btn-outline-primary" htmlFor="expandableView">
                                                    <i className="fas fa-list me-1"></i>Expandable
                                                </label>

                                                <input
                                                    type="radio"
                                                    className="btn-check"
                                                    name="viewMode"
                                                    id="modalView"
                                                    checked={viewMode === 'modal'}
                                                    onChange={() => setViewMode('modal')}
                                                />
                                                <label className="btn btn-outline-primary" htmlFor="modalView">
                                                    <i className="fas fa-external-link-alt me-1"></i>Modal
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="table-responsive">
                                {
                                    isProcessing === true ?
                                        <div className="text-center"><Spinner /></div>
                                        :
                                        <table className="table text-nowrap table-responsive-sm table-responsive-md table">
                                            <thead className="thead--color">
                                                <tr>
                                                    <th>#</th>
                                                    <th>Employee</th>
                                                    <th>Leave Date</th>
                                                    <th>Leave Type</th>
                                                    <th>Leave Reason</th>
                                                    {viewMode === 'modal' && <th className="text-center">Actions</th>}
                                                    {viewMode === 'expandable' && <th className="text-center">Details</th>}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    paginatedLeaves.map((le, index) => {
                                                        const leaveData = {
                                                            ...le,
                                                            employeeCode: le.employeeCode,
                                                            employeeName: le.employeeName,
                                                            leaveTypeName: le.leaveTypeName,
                                                            leaveTypeCode: le.leaveTypeCode,
                                                            startDate: le.startDate,
                                                            endDate: le.endDate,
                                                            reason: le.reason,
                                                            pCode: selectedPcode,
                                                            transType: 'Approved', // Since this is approved leaves
                                                            leaveAutoNo: le.leaveAutoNo,
                                                            isHalfDay: le.isHalfDay,
                                                            noPay: le.noPay,
                                                            noofLeaves: le.noofLeaves,
                                                            requestDate: le.requestDate,
                                                            requestedBy: le.requestedBy,
                                                            approverComments: le.approverComments
                                                        };

                                                        if (viewMode === 'expandable') {
                                                            return (
                                                                <ExpandableTableRow
                                                                    key={index}
                                                                    expandedContent={
                                                                        <LeaveDetailsSummary
                                                                            leaveData={leaveData}
                                                                            showBalanceInfo={true}                                                                            
                                                                            compact={true}
                                                                        />
                                                                    }
                                                                >
                                                                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                                                    <td>
                                                                        <div className="employee-info">
                                                                            <strong>({le.employeeCode})</strong>
                                                                            <br />
                                                                            <small className="text-muted">{le.employeeName}</small>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="date-range">
                                                                            <small className="text-primary">
                                                                                {formatDate(le.startDate)} - {formatDate(le.endDate)}
                                                                            </small>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span className="badge bg-info">{le.leaveTypeName}</span>
                                                                    </td>
                                                                    <td>
                                                                        <div className="reason-preview">
                                                                            {le.reason && le.reason.length > 50
                                                                                ? `${le.reason.substring(0, 50)}...`
                                                                                : le.reason || 'N/A'
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                </ExpandableTableRow>
                                                            );
                                                        } else {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                                                    <td>
                                                                        <div className="employee-info">
                                                                            <strong>({le.employeeCode})</strong>
                                                                            <br />
                                                                            <small className="text-muted">{le.employeeName}</small>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="date-range">
                                                                            <small className="text-primary">
                                                                                {formatDate(le.startDate)} - {formatDate(le.endDate)}
                                                                            </small>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span className="badge bg-info">{le.leaveTypeName}</span>
                                                                    </td>
                                                                    <td>
                                                                        <div className="reason-preview">
                                                                            {le.reason && le.reason.length > 50
                                                                                ? `${le.reason.substring(0, 50)}...`
                                                                                : le.reason || 'N/A'
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <button
                                                                            className="btn btn-sm btn-outline-primary"
                                                                            onClick={() => handleViewDetails(leaveData)}
                                                                            title="View Details"
                                                                        >
                                                                            <i className="fas fa-eye"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    })
                                                }
                                                {paginatedLeaves.length === 0 && !isProcessing && (
                                                    <tr>
                                                        <td colSpan="6" className="text-center text-muted py-4">
                                                            <i className={`fas ${empLeave.length === 0 ? 'fa-inbox' : 'fa-filter'} fa-2x mb-2`}></i>
                                                            <br />
                                                            {empLeave.length === 0
                                                                ? 'No approved leaves found for the selected period'
                                                                : 'No leaves match the current filters'
                                                            }
                                                            {empLeave.length > 0 && (
                                                                <div className="mt-2">
                                                                    <button
                                                                        className="btn btn-sm btn-outline-primary"
                                                                        onClick={clearFilters}
                                                                    >
                                                                        Clear Filters
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                }
                            </div>

                            {/* Pagination */}
                            {filteredLeaves.length > itemsPerPage && !isProcessing && (
                                <div className="d-flex justify-content-between align-items-center mt-2">
                                    <div>
                                        <small className="text-muted">
                                            Showing {(currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, filteredLeaves.length)} of {filteredLeaves.length} entries
                                        </small>
                                    </div>
                                    <nav aria-label="Table pagination">
                                        <ul className="pagination pagination-sm mb-0">
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                >
                                                    Previous
                                                </button>
                                            </li>

                                            {[...Array(totalPages)].map((_, i) => {
                                                const page = i + 1;
                                                // Show first page, current page with neighbors, and last page
                                                if (
                                                    page === 1 ||
                                                    page === totalPages ||
                                                    (page >= currentPage - 1 && page <= currentPage + 1)
                                                ) {
                                                    return (
                                                        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={() => handlePageChange(page)}
                                                            >
                                                                {page}
                                                            </button>
                                                        </li>
                                                    );
                                                } else if (
                                                    (page === currentPage - 2 && currentPage > 3) ||
                                                    (page === currentPage + 2 && currentPage < totalPages - 2)
                                                ) {
                                                    return <li key={page} className="page-item disabled"><span className="page-link">...</span></li>;
                                                }
                                                return null;
                                            })}

                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Leave Details Modal */}
            <LeaveDetailsModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                leaveData={selectedLeaveData}
                showBalanceInfo={true}
            />

        </>
    );
}